import {
  AfterViewInit,
  QueryList,
  Component,
  OnInit,
  forwardRef,
  Injector,
  HostListener,
  ViewChild,
  ViewChildren,
  AfterViewChecked,
  ElementRef,
  OnDestroy,
  TrackByFunction,
  ChangeDetectorRef
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ACL_WTAX_LINE_COLUMNS, ColumnOptions } from '@core';
import { ACLService, ACLType } from '@delon/acl';
import { _HttpClient, SettingsService } from '@delon/theme';
import { Store } from '@ngrx/store';
import { DeferredVatLookupService } from '@shared-feature/services/lookup-deferredvat.service';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzResizeEvent } from 'ng-zorro-antd/resizable';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { Subject, takeUntil } from 'rxjs';
import { removeRecentAccountAction } from 'src/app/actions/account';
import { removeRecentAgentAction } from 'src/app/actions/agent';
import { removeRecentCustomerAction } from 'src/app/actions/customer/action';
import { removeRecentProjectAction } from 'src/app/actions/project';
import {
  removeRecentTaxAction,
  restrictCreateTaxToOutputTaxAction
} from 'src/app/actions/tax';
import { removeRecentTermAction } from 'src/app/actions/term';
import { UserDefaultService } from 'src/app/shared/services/user-default.service';
import { ArdnService } from 'src/app/routes/ar/ardn/ardn.service';
import { CustomerInfoModalComponent } from 'src/app/shared-feature/components/modal/customer-info-modal/customer-info-modal.component';
import { GLAccountSelectComponent } from 'src/app/shared-feature/components/select/gl-account-select/gl-account-select.component';
import { DocBaseService } from 'src/app/shared-feature/services/_base/doc-base.service';
import { DocListBaseService } from 'src/app/shared-feature/services/_base/doc-list-base.service';
import { AutoCodeService } from 'src/app/shared-feature/services/auto-code.service';
import { TransactionDetailColumnAdjustService } from 'src/app/shared-feature/services/transaction-detail-column-adjust.service';
import { TranscationDetailKeyKownService } from 'src/app/shared-feature/services/transcation-detail-key-kown.service';
import { EditView } from 'src/app/shared/base/edit-view';
import { AttachmentTableComponent } from 'src/app/shared/components/attachment-table/attachment-table.component';
import { PaginatedTableComponent } from 'src/app/shared/components/paginated-table/paginated-table.component';
import { AttachmentChangePayload } from 'src/app/shared/models/attachment-change.model';

import { ArdnListService } from '../ardn-list.service';

@Component({
  selector: 'app-ardn-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.less'],
  standalone: false,
  providers: [
    {
      provide: DocListBaseService,
      useExisting: forwardRef(() => ArdnListService)
    },
    {
      provide: DocBaseService,
      useExisting: forwardRef(() => ArdnService)
    },
    {
      provide: ArdnService,
      useFactory: (injector: Injector) => new ArdnService(injector),
      deps: [Injector]
    },
    {
      provide: AutoCodeService,
      useFactory: (http: _HttpClient) => new AutoCodeService(http),
      deps: [_HttpClient]
    }
  ]
})
export class ArdnDetailComponent
  extends PaginatedTableComponent<ArdnService>
  implements OnInit, AfterViewChecked, OnDestroy, AfterViewInit
{
  @ViewChild('custModal') customerInfoModal!: CustomerInfoModalComponent;
  @ViewChildren(GLAccountSelectComponent)
  stockSelections!: QueryList<GLAccountSelectComponent>;
  @ViewChild('TextArea') notesTextArea!: ElementRef;
  @ViewChild('linesTable') nzTableComponent?: NzTableComponent<any>;
  @ViewChild('birComponent') birComponent!: any;
  @ViewChild('customerNameInput') customerNameInput!: any;
  @ViewChild('attachmentTable') attachmentTable!: AttachmentTableComponent;

  isEnableDeferredVatLookupSrv: boolean = true;


  get additionalData() {
    return {
      customerName: this.form.get('customerName')?.value
    };
  }

  get id() {
    return this.route.snapshot.params['id'];
  }
  get title() {
    if (this.isPast) {
      return 'Past Customer Debit Note';
    }
    return 'Customer Debit Note';
  }
  //editing = false;

  get isPast() {
    return this.dataSrv.form.controls.isPast.value;
  }

  get country() {
    return this.settings.user['company'].country;
  }

  columns: Array<{
    key: string;
    title: string;
    width: string;
    name: string;
    align?: string;
    acl?: ACLType;
  }> = [
    { key: 'account', title: 'Account', width: '120px', name: 'account' },
    {
      key: 'accountName',
      title: 'Account Name',
      width: '180px',
      name: 'accountName'
    },
    {
      key: 'description',
      title: 'Description',
      width: '240px',
      name: 'description'
    },
    {
      key: 'referenceNo',
      title: 'Ref No.',
      width: '180px',
      name: 'referenceNo'
    },
    {
      key: 'amount',
      title: 'Amount',
      width: '120px',
      align: 'right',
      name: 'accAmount'
    },
    {
      key: 'project',
      title: 'Project',
      width: '120px',
      acl: { ability: ['m1.256'] },
      name: 'project'
    },
    {
      key: 'taxCode',
      title: 'Tax',
      width: '120px',
      acl: { ability: ['m1.512'] },
      name: 'taxCode'
    },
    {
      key: 'tariffCode',
      title: 'Tariff Code',
      width: '120px',
      align: 'left',
      acl: { ability: ['country.MY', 'm1.8388608'], mode: 'allOf' },
      name: 'tariffCode'
    },
    {
      key: 'wTaxCode',
      title: 'W/Tax',
      width: '120px',
      acl: ACL_WTAX_LINE_COLUMNS,
      name: 'wTaxCode'
    },
    {
      key: 'taxAmount',
      title: 'Tax Amount',
      width: '120px',
      align: 'right',
      acl: { ability: ['m1.512'], mode: 'allOf' },
      name: 'taxAmount'
    },
    // {
    //   key: 'taxExemptionRate',
    //   name: 'taxExemptionRate',
    //   title: 'Exempted Rate',
    //   width: '120px',
    //   align: 'left',
    //   acl: { ability: ['m1.512'], mode: 'allOf' }
    // },
    // {
    //   key: 'taxExemptionAmount',
    //   name: 'taxExemptionAmount',
    //   title: 'Exempted Tax Amount',
    //   width: '120px',
    //   align: 'right',
    //   acl: { ability: ['m1.512'], mode: 'allOf' }
    // },
    {
      key: 'taxAmountAdjustment',
      title: 'Tax Adjustment',
      width: '120px',
      align: 'right',
      acl: { ability: ['m1.512'], mode: 'allOf' },
      name: 'taxAmountAdjustment'
    },
    {
      key: 'rentalLeaseExemptedRate',
      title: 'Rental/Lease Exempted Rate',
      width: '120px',
      align: 'left',
      acl: { ability: ['country.MY', 'm1.512'], mode: 'allOf' },
      name: 'rentalLeaseExemptedRate'
    },
    {
      key: 'rentalLeaseExemptedTaxAmount',
      title: 'Rental/Lease Exempted Tax Amount',
      width: '120px',
      align: 'right',
      acl: { ability: ['country.MY', 'm1.512'], mode: 'allOf' },
      name: 'rentalLeaseExemptedTaxAmount'
    },
    {
      key: 'wTaxAmount',
      title: 'W/Tax Amount',
      width: '120px',
      align: 'right',
      acl: ACL_WTAX_LINE_COLUMNS,
      name: 'wTaxAmount'
    },
    {
      key: 'wTaxAmountAdjustment',
      title: 'W/Tax Adjustment',
      width: '120px',
      align: 'right',
      acl: ACL_WTAX_LINE_COLUMNS,
      name: 'wTaxAmountAdjustment'
    }
  ];

  initialColumns = this.columns;

  get form() {
    return this.dataSrv.form;
  }
  get details() {
    return this.form.controls.details;
  }
  destroy$ = new Subject<void>();

  public recentTaxControlIndex?: number;
  public recentAccountControlIndex?: number;
  constructor(
    private route: ActivatedRoute,
    public msgSrv: NzMessageService,
    public override dataSrv: ArdnService,
    private acl: ACLService,
    public settings: SettingsService,
    public router: Router,
    private injector: Injector,
    public override keyDownService: TranscationDetailKeyKownService,
    public columnAdjustService: TransactionDetailColumnAdjustService,
    protected override cdr: ChangeDetectorRef,
    private store: Store<{
      customer: { recentCustomer: any };
      agent: { recentAgent: any };
      project: { recentProject: any };
      term: { recentTerm: any };
      account: { recentAccount: any };
      tax: { recentTax: any };
    }>,
    private userDefaultService: UserDefaultService
  ) {
    super(dataSrv, cdr, keyDownService);

    this.dataSrv.newLineAdded$.subscribe(() => {
      this.newlyAddedLine = true;
    });

    this.dataSrv.lineValueChanged.subscribe(({ line, controlName }) => {
      const index = this.dataSrv.details.controls.indexOf(line);
      this.keyDownService.focusNextElement(
        index,
        controlName,
        this.columns,
        this.editableCells.toArray()
      );
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  @ViewChildren('inputWrapper') inputWrappers!: QueryList<ElementRef>;

  ngAfterViewInit(): void {
    this.inputWrappers.forEach(wrapper => {
      this.userDefaultService.setRequiredValidation(wrapper);
    });

    this.dataSrv.validateTaxDate();

    this.visibleColumns = this.columns.filter(
      col => (!col.acl || this.acl.canAbility(col.acl)) 
    ) as ColumnOptions[];
    this.keyDownService.updateColumnOrder(this.visibleColumns);
  }

  ngOnInit(): void {
    this.dataSrv.setComponentRef(this);
    this.checkDeferredVatSetting();
    this.columns = this.columns.filter(
      col => !col.acl || this.acl.canAbility(col.acl)
    );

    this.initialColumns = this.initialColumns.filter(
      col => !col.acl || this.acl.canAbility(col.acl)
    );

    this.columnAdjustService.setInitialColumn(this.initialColumns);
    const savedOrder = this.columnAdjustService.loadColumnOrder('ardn');
    if (savedOrder) {
      this.columns.sort((a, b) => savedOrder[a.key] - savedOrder[b.key]);
    }
    this.store.dispatch(removeRecentCustomerAction());
    this.store.dispatch(removeRecentAgentAction());
    this.store.dispatch(removeRecentProjectAction());
    this.store.dispatch(removeRecentTaxAction());
    this.store.dispatch(removeRecentAccountAction());
    this.store.dispatch(removeRecentTermAction());
    if (this.id == 0) {
      this.onProjectCreate();
      this.onAgentAdded();
      this.onAddNewCustomer();
      this.onAccountCreate();
      this.onTaxCreate();
      this.onTermAdded();
    }
  }

  checkDeferredVatSetting() {
    if (this.country === 'PH') {
      this.injector
        .get(DeferredVatLookupService)
        .loadDeferredVatSettings()
        .subscribe(res => {
          this.isEnableDeferredVatLookupSrv = res === null ? false : res;
          this.dataSrv.form.controls.enableDeferredVat.setValue(this.isEnableDeferredVatLookupSrv);
        });
    }
  }

  private onTermAdded() {
    this.store
      .select('term')
      .pipe(takeUntil(this.destroy$))
      .subscribe(term => {
        if (this.dataSrv.form.controls.termId.value) return;
        if (term.recentTerm) {
          this.dataSrv.form.controls.termId.setValue(term.recentTerm.id);
          this.dataSrv.form.controls.term.setValue(term.recentTerm);
        }
      });
  }
  private onAccountCreate() {
    this.store
      .select('account')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentAccount === null) return;
        if (
          isNull(this.recentAccountControlIndex) ||
          isUndefined(this.recentAccountControlIndex) ||
          this.form.controls.details.at(this.recentAccountControlIndex).controls
            .account.value
        )
          return;
        const rowControl = this.form.controls.details.at(
          this.recentAccountControlIndex
        );
        const accountInfo = {
          ...state.recentAccount
        };
        rowControl.controls.account.setValue(accountInfo);
        rowControl.controls.accountId.setValue(accountInfo.id);
      });
  }
  private onTaxCreate() {
    this.store
      .select('tax')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentTax === null) return;
        if (
          isNull(this.recentTaxControlIndex) ||
          isUndefined(this.recentTaxControlIndex) ||
          this.form.controls.details.at(this.recentTaxControlIndex).controls
            .taxCode.value
        )
          return;
        const rowControl = this.form.controls.details.at(
          this.recentTaxControlIndex
        );
        rowControl.controls.taxCode.setValue(state.recentTax);
        rowControl.controls.taxCodeId.setValue(state.recentTax.id);
      });
  }
  private onProjectCreate() {
    this.store
      .select('project')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentProject === null) return;
        if (
          this.form.controls.projectId.value ||
          this.form.controls.project.value
        )
          return;
        this.form.controls.project.setValue(state.recentProject);
        this.form.controls.projectId.setValue(state.recentProject.id);
      });
  }
  private onAgentAdded() {
    this.store
      .select('agent')
      .pipe(takeUntil(this.destroy$))
      .subscribe(agent => {
        if (this.dataSrv.form.controls.agentId.value) return;
        if (agent.recentAgent) {
          this.dataSrv.form.controls.agentId.setValue(agent.recentAgent.id);
          this.dataSrv.form.controls.agent.setValue(agent.recentAgent);
        }
      });
  }
  onCustomerChange() {
    if (this.dataSrv.editing){
      // Focus on customer name field after customer selection
      setTimeout(() => {
        if (this.customerNameInput) {
          this.customerNameInput.focus();
        }
      }, 100);
    }
  }

  onAddNewCustomer() {
    this.store
      .select('customer')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentCustomer === null) return;
        this.form.controls.customer.setValue(state.recentCustomer);
        this.form.controls.customerId.setValue(state.recentCustomer?.id);
        this.form.controls.customerName.setValue(state.recentCustomer?.name);
        this.form.controls.customerPhone.setValue(
          state.recentCustomer?.phoneNo1
        );
        this.form.controls.customerTinType.setValue(
          state.recentCustomer?.tinType
        );
      });
  }

  get collapsed() {
    return this.settings.layout.collapsed;
  }

  get modified() {
    return this.dataSrv.modified;
  }

  onResize({ width }: NzResizeEvent, col: any): void {
    col.width = `${width}px`;
  }
  updateLatestRate() {
    this.dataSrv.updateLatestRate();
  }

  updateCustModal(data: any) {
    this.dataSrv.updateCustInfo(data);
  }

  openCustModal() {
    // Pass existing data to ensure data recovery can be done when changes are cancelled
    this.customerInfoModal.show(this.dataSrv.form.value, 'DN');
  }

  ngAfterViewChecked() {
    if (this.newlyAddedLine) {
      this.focusNewLineStockSelect();
      this.newlyAddedLine = false;
    }
  }

  /**
   * Focuses on the last stock selection element in the array.
   */
  private focusNewLineStockSelect() {
    const stockSelectionArray = this.stockSelections.toArray();
    if (stockSelectionArray.length > 0) {
      const newLineStockSelect =
        stockSelectionArray[stockSelectionArray.length - 1];
      newLineStockSelect.focus();
    }
  }

  columnOrder: string[] = [];
  override selectComponentArray: string[] = [
    'stock',
    'project',
    'uom',
    'stockLocation',
    'taxCode',
    'wTaxCode',
    'account',
    'classification',
    'tariffCode',
    'taxAmountAdjustment',
    'wTaxAmountAdjustment'
  ];
  @ViewChildren('editableCell') override editableCells!: QueryList<ElementRef>;


  timestamp() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    var formattedTimestamp = null;
    if (this.settings.user['country'] === 'MY')
      formattedTimestamp = `${day}/${month}/${year} ${hours}:${minutes}:${seconds} - ${this.settings.user['displayName']}:`;
    if (this.settings.user['country'] === 'PH')
      formattedTimestamp = `${month}/${day}/${year} ${hours}:${minutes}:${seconds} - ${this.settings.user['displayName']}:`;
    if (this.dataSrv.form.controls.notes.value)
      formattedTimestamp = `${this.dataSrv.form.controls.notes.value}\n${formattedTimestamp}`;

    this.dataSrv.form.controls.notes.setValue(formattedTimestamp);
    this.notesTextArea.nativeElement.focus();
  }

  collectAttachmentChanges(): AttachmentChangePayload | null {
    if (this.attachmentTable) {
      return this.attachmentTable.getDeferredAttachmentChanges();
    }
    return null;
  }

  clearAttachmentChanges(): void {
    if (this.attachmentTable) {
      this.attachmentTable.clearDeferredChanges();
    }
  }
}
